<template>
  <modal
      :modal-id="modalId"
      :title="modalTitle"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader"/>
      <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="addUrl"
      >
        <div class="form-group row align-items-center">
          <label class="col-sm-4 mb-0">{{ $t("document_category") }}</label>
          <app-input
              class="col-sm-8"
              type="search-select"
              :placeholder="$t('select_document_category')"
              :list="documentCategories"
              v-model="category_id"
          />
        </div>
        <div class="form-group row align-items-center" v-if="subCategory.length > 0">
          <label class="col-sm-4 mb-0">{{ $t("sub_category") }}</label>
          <app-input
              class="col-sm-8"
              type="search-select"
              :placeholder="$t('select_sub_category')"
              :list="subCategory"
              v-model="subcategory_id"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_type" class="col-sm-4 mb-0">
            {{ $t("type") }}
          </label>
          <app-input
              id="inputs_type"
              class="col-sm-8"
              type="text"
              v-model="inputs.type"
              :required="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_document_name" class="col-sm-4 mb-0">
            {{ $t("document_name") }}
          </label>
          <app-input
              id="inputs_document_name"
              class="col-sm-8"
              type="text"
              v-model="inputs.document_name"
              :required="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_expiry" class="col-sm-4 mb-0">
            {{ $t("expiry") }}
          </label>
          <app-input
              class="col-sm-8"
              type="radio"
              :list="expiryCondition"
              v-model="is_expiry"
          />
        </div>
        <div class="form-group row align-items-center" v-if="is_expiry == 1">
          <label for="inputs_phone" class="col-sm-4 mb-0">
            {{ $t("expiry_date") }}
          </label>
          <app-input
              id="inputs_expiry_date"
              class="col-sm-8"
              type="date"
              v-model="inputs.expiry_date"
              :required="is_expiry == 1 ? true : false"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_description" class="col-sm-4 mb-0">
            {{ $t("description") }}
          </label>
          <app-input
              id="inputs_edescription"
              class="col-sm-8"
              type="textarea"
              v-model="inputs.description"
          />
        </div>
        <div v-if="fields.length">
          <div class="form-group row align-items-center" v-for="(type, index) in fields" :key="index">
            <label for="inputs_document_name" class="col-sm-4 mb-0">
              {{ type.field }}
            </label>
            <app-input
                id="inputs_document_name"
                class="col-sm-8"
                type="text"
                v-model="extra_fields[type.id]"
                :required="true"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_email" class="col-sm-4 mb-0">
            {{ $t("is_public") }}
          </label>
          <app-input
              class="mt-2 pt-1 col-sm-6"
              type="radio"
              :list="publicRadio"
              v-model="inputs.is_public"
              :required="true"
          />
        </div>
        <div class="form-group row mb-0">
          <label class="col-sm-4 mb-sm-0">
            {{ $t("upload") }}
          </label>

          <app-input
              class="col-sm-8"
              type="file"
              :label="$t('upload_your_file')"
              v-model="inputs.file"
          />
          <!-- <small class="text-muted font-italic">
            {{ $t("recommended_custom_file_validation") }}
          </small> -->
        </div>
        <!-- <div class="form-group row align-items-center">
          <div class="col-sm-12 mb-0">
            <label for="inputs_status">
              {{ $t("upload") }}
            </label>
            <app-input
              type="dropzone"
              :required="true"
              v-model="dropzone_files"
            />
            <small class="text-muted font-italic">
              {{ $t("recommended_dropzone_file_validation") }}
            </small>
          </div>
        </div> -->
        <!-- <div class="form-group row align-items-center">
          <div
            class="col-lg-2 col-md-2 col-sm-12"
            v-for="(val, index) in uploadedFiles"
            :key="index"
          >
            <div class="form-group">
              <img :src="val.path" alt="uploaded file" class="img-thumbnail" />
            </div>
            <span
              class="dz-remove"
              style="cursor: pointer"
              @click="deletefile(val.id, index)"
              >Remove file</span
            >
          </div>
        </div> -->
      </form>
    </template>
  </modal>
</template>

<script>
import {FormMixin} from "../../../../../../core/mixins/form/FormMixin.js";
import {ModalMixin} from "../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../Config/ApiUrl";
import {
  axiosPost,
  axiosDelete,
  axiosGet,
} from "../../../../../Helpers/AxiosHelper.js";
import AppLibrary from "../../../../../Helpers/AppLibrary";

export default {
  name: "AddModal",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    customerCompany: {}
  },
  data() {
    return {
      documentCategories: [],
      subCategory: [],
      uploadedFiles: [],
      addUrl: actions.MYDOCUMENT_STORE,
      preloader: false,
      dropzone_files: [],
      inputs: {
        // expiry_date: new Date(),
      },
      expiryCondition: [
        {id: "1", value: "Yes"},
        {id: "0", value: "No"},
      ],
      is_expiry: '1',
      extra_fields: {},
      category_id: '',
      subcategory_id: '',
      modalId: "document-add-modal",
      modalTitle: this.$t("add"),
      fields: [],
      publicRadio: [
        {id: "1", value: "Yes"},
        {id: "0", value: "No"},
      ],
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      // this.addUrl = actions.MYDOCUMENT_UPDATE;
      // this.preloader = true;
    }
  },
  watch: {
    category_id() {
      let category_id = this.category_id
      this.getDocumentFields(category_id);

      //Sub CAtegory
      this.getSubCategory(category_id);
    },
    subcategory_id() {
      let subcategory_id = this.subcategory_id
      this.getDocumentFields(subcategory_id);
    }
  },
  methods: {
    submit() {
      if (this.inputs.expiry_date){
        this.inputs.expiry_date = this.getDateFormatForBackend(
            this.inputs.expiry_date
        );
      }
      if (this.is_expiry === '0'){
        this.inputs.expiry_date = '';
      }

      if (typeof this.inputs.file['url'] != 'undefined') {
        this.inputs.file_type = 'old_file';
      } else {
        this.inputs.file_type = 'new_file';
      }

      if (this.customerCompany) {
        this.inputs.user_id = this.customerCompany?.company_admin?.id
      }
      if (this.supplierRequestCertificate){
        this.inputs.certificate_id = this.supplierRequestCertificate.compliance_certificate_id
        this.inputs.user_id = this.supplierRequestCertificate.user.id

      }


      if (this.modalTitle == "Edit") {
        let formData = new FormData();
        this.inputs.category_id = this.category_id;

        Object.keys(this.inputs).forEach((key) => {
          formData.append(key, this.inputs[key]);
        });

        axiosPost(actions.MYDOCUMENT_UPDATE, formData)
            .then((res) => {

              this.afterSuccess(res);
            })
            .catch((error) => {

              this.$toastr.e(error.data.type);
            })
            .finally(() => {
              this.preloader = false;
              this.closeModal();
            });
      } else {

        // this.inputs.category_id = this.category_id;
        let formData = new FormData();
        this.inputs.category_id = this.category_id;
        Object.keys(this.inputs).forEach((key) => {
          formData.append(key, this.inputs[key]);
        });

        let data = [];
        Object.entries(this.extra_fields).forEach((obj) => {
          data = [...data, obj];
        });
        formData.append('extra', JSON.stringify(data));

        this.save(formData);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.inputs.document_name = response.data.name;
      this.inputs.file = response.data.file.path;
      this.category_id = response.data.category_id;
      if (response.data.expiry_date == null) {
        this.is_expiry = '0';
      }
      // this.uploadedFiles = response.data.files;
      this.preloader = false;
    },

    // deletefile(id, index) {
    //   this.uploadedFiles.splice(index, 1);
    //   axiosDelete(actions.UPLOADED_DOCUMENT_DELETE + "/" + id)
    //     .then((res) => {
    //       
    //       this.$toastr.s(res.data.message);
    //     })
    //     .catch((error) => {
    //       this.$toastr.e(error);
    //     })
    //     .finally(() => {});
    // },
    getdocumentCategories() {
      axiosGet(actions.DOCUMENT_CATEGORIES)
          .then((res) => {
            this.documentCategories = res.data;
          })
          .catch((error) => {
            this.$toastr.e(error);
          })
          .finally(() => {
          });
    },
    getDocumentFields(id) {

      axiosGet(actions.DOCUMENT_EXTRA_FIELDS + '/' + id)
          .then((res) => {
            this.fields = res.data;
          })
          .catch((error) => {
            this.$toastr.e(error);
          })
          .finally(() => {
          });
    },
    getSubCategory(id) {
      axiosGet(actions.DOCUMENT_SUB_CATEGORIES + '/' + id)
          .then((res) => {
            this.subCategory = res.data;
          })
          .catch((error) => {
            this.$toastr.e(error);
          })
          .finally(() => {
          });

    },
  },

  mounted() {
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
    this.getdocumentCategories();
  },
  computed:
      {
    supplierRequestCertificate(){
      return this.$store.state.sharedData.sharedData.selectedCertificate
    }
  }
};
</script>
